import BackgroundVideo from '../../../resources/scripts/helpers/background-video';

class BrixImage {
  static init(...parameters) {
    return new BrixImage(...parameters);
  }

  constructor(block) {
    if (block) {
      const backgroundVideoWrapper = document.querySelector(`#${block.id} > .background > .video`);

      if (backgroundVideoWrapper) {
        BackgroundVideo.init(block);
      }
      this.revealOnScroll(block);
    }
  }

  revealOnScroll(block) {
    const animations = ['slide-in-bottom', 'slide-in-left', 'slide-in-right', 'slide-in-top', 'fade-in'];
    const img = block.querySelector('img');
    if (!img) return;

    // eslint-disable-next-line no-restricted-syntax
    for (const name of animations) {
      if (block.classList.contains(name)) {
        img.style.opacity = 0;
      }
    }

    const handleAnimation = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // eslint-disable-next-line no-restricted-syntax
          for (const name of animations) {
            if (block.classList.contains(name)) {
              entry.target.classList.add(`${name}-animation`);
            }
          }
          observer.unobserve(entry.target);
        }
      });
    };
    const observer = new IntersectionObserver(handleAnimation, { threshold: 0.3 });
    observer.observe(img);
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-image', BrixImage.init);
}
